import { render } from "./BrowseDrawer.vue?vue&type=template&id=fadda408"
import script from "./BrowseDrawer.vue?vue&type=script&lang=js"
export * from "./BrowseDrawer.vue?vue&type=script&lang=js"
script.render = render

export default script